<div>
    <v-form ref="form">
        <div v-if="postQualification.hasNameDetails">
            <h2 class="mb-4">Personal data</h2>
            <v-row>
                <v-col cols="6">
                    <v-select
                        :label="salutationData.label"
                        :items="salutations"
                        v-model="nameDetails.salutation"
                        :rules="salutationData.rules"
                        item-title="name"
                        item-value="id"
                        variant="outlined"
                        validate-on="blur"></v-select>
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        :label="titleData.label"
                        v-model="nameDetails.title"
                        :rules="titleData.rules"
                        variant="outlined"
                        validate-on="blur"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    <v-text-field
                        :label="firstNameData.label"
                        v-model="nameDetails.firstName"
                        :rules="firstNameData.rules"
                        variant="outlined"
                        validate-on="blur"></v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        :label="lastNameData.label"
                        v-model="nameDetails.lastName"
                        :rules="lastNameData.rules"
                        variant="outlined"
                        validate-on="blur"></v-text-field>
                </v-col>
            </v-row>
        </div>
        <div v-if="postQualification.hasAddressDetails">
            <h2 class="mb-4">Address</h2>
            <v-row>
                <v-col cols="6">
                    <v-select
                        :label="addressTypesData.label"
                        :items="addressTypes"
                        v-model="addressDetails.addressType"
                        :rules="addressTypesData.rules"
                        @update:model-value="onAddressTypeInput"
                        item-title="name"
                        item-value="id"
                        variant="outlined"
                        validate-on="blur"></v-select>
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        v-if="isBusinessAddress"
                        :label="businessNameData.label"
                        v-model="addressDetails.buName"
                        :rules="businessNameData.rules"
                        variant="outlined"
                        validate-on="blur"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    <v-text-field
                        :label="streetData.label"
                        v-model="addressDetails.street"
                        :rules="streetData.rules"
                        variant="outlined"
                        validate-on="blur"></v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        :label="houseNumberData.label"
                        v-model="addressDetails.houseNumber"
                        :rules="houseNumberData.rules"
                        variant="outlined"
                        validate-on="blur"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    <v-text-field
                        :label="zipCodeData.label"
                        v-model="addressDetails.zipCode"
                        :rules="zipCodeData.rules"
                        variant="outlined"
                        validate-on="blur"></v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        :label="cityData.label"
                        v-model="addressDetails.city"
                        :rules="cityData.rules"
                        variant="outlined"
                        validate-on="blur"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    <v-select
                        :label="countryData.label"
                        :items="countries"
                        v-model="addressDetails.countryCode"
                        :rules="countryData.rules"
                        item-title="name"
                        item-value="code"
                        variant="outlined"
                        validate-on="blur"></v-select>
                </v-col>
            </v-row>
        </div>
        <div v-if="postQualification.hasCarDetails">
            <h2 class="mb-4">Vehicle data</h2>
            <v-row>
                <v-col cols="6">
                    <v-text-field
                        :label="vinData.label"
                        v-model="carDetails.vin"
                        :rules="vinData.rules"
                        variant="outlined"
                        validate-on="blur"></v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-select
                        :items="countries"
                        :label="countryOfRegistrationCode.label"
                        v-model="carDetails.countryOfRegistrationCode"
                        :rules="countryOfRegistrationCode.rules"
                        item-title="name"
                        item-value="code"
                        variant="outlined"
                        validate-on="blur"></v-select>
                </v-col>
            </v-row>
        </div>
        <v-btn
            color="primary"
            size="large"
            variant="flat"
            tile
            :loading="isSubmitting"
            @click="submit">
            Send
        </v-btn>
    </v-form>
</div>